"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.newListingsPageTypeFromSearchType = void 0;
var newListingsPageTypeFromSearchType = searchType => {
  switch (searchType) {
    case 'new-listings':
    case 'strict-new-listings':
      return 'new-listings';
    case 'new-price':
      return 'new-price';
    default:
      return null;
  }
};
exports.newListingsPageTypeFromSearchType = newListingsPageTypeFromSearchType;